{
	"logo": "Logo",
	"fileUpload": "Haga clic o arrastre aquí para adjuntar",
	"noInformation": "Sin información",
	"toggleProducts": "No, solo este producto",
	"comingSoon": "Próximamente"
}
